module.exports = __webpack_public_path__ + "images/how-to-choose-best-affiliate-program-1.jpg";